import type { ReadonlyDeep } from 'type-fest';

import { ResolvableIdInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';
import type { ResolvableIdCmp_ResolvableId } from '../../../components/ResolvableFields/ResolvableId';

export function resolvableIdForm2ApiMapper(
  resolvableId: ReadonlyDeep<ResolvableIdCmp_ResolvableId>,
): ReadonlyDeep<ResolvableIdInput> {
  return pruneInput(resolvableId, ResolvableIdInput);
}
